export default "__VITE_ASSET__BxKgMVVn__"